module.exports = __webpack_public_path__ + "img/more.d3fb04ef.svg";